import axios from "axios";
import { getDocumentMeta } from "utils/getDocumentMeta";

export const ciamSessionRequest = async (params: {
  id_token: string;
}): Promise<void> => {
  const { id_token } = params;
  const path = getDocumentMeta("dph_routing") === "1"
    ? "/dph-handoff/ciam_session"
    : "/api/ciam_session";
  const { data } = await axios.post(path, {
    id_token
  },{
    headers: {
        'Content-Type': 'application/json'
    }
});

  return data;
};
